module.exports = __webpack_public_path__ + "static/edit_content_395x272-46008bbf8f0050dee1857edf1f4a15ac.png";